import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalService } from '../services/database/local.service';

export const isAuthenticatedGuard = (redirectUrl: string): CanActivateFn => {
  return (route, state) => {
    const localService = inject(LocalService);
    const router = inject(Router);

    if (localService.isLoggedIn) {
      router.navigate([redirectUrl]);
      return false;
    }
    return true;
  };
};

